import React, { useEffect } from "react";
import "../sell-fast-page/info-page.css";

const SECTIONS = [
  {
    title: "Information We Collect",
    points: [
      "Account information: name, email address and mobile number provided during registration.",
      "Listing content: vehicle details, descriptions, photos and pricing that you submit when posting an ad.",
      "Usage data: pages visited, search queries, device type, browser and IP address collected automatically.",
      "Communications: messages sent through AdsOne.lk's contact features between buyers and sellers.",
    ],
  },
  {
    title: "How We Use Your Information",
    points: [
      "To create and manage your seller account and authenticate your identity.",
      "To publish and manage your vehicle listings on AdsOne.lk.",
      "To send transactional emails such as registration confirmation, email verification and password resets.",
      "To improve the platform through analytics, research and product development.",
      "To comply with legal obligations and cooperate with authorities where required by law.",
    ],
  },
  {
    title: "Sharing Your Information",
    points: [
      "We do not sell your personal data to third parties.",
      "Your contact number is displayed on your listings so potential buyers can reach you directly.",
      "We may share data with trusted service providers (e.g. email delivery, cloud storage) solely to operate the platform.",
      "We may disclose information to law enforcement or regulatory bodies where required by Sri Lankan law.",
    ],
  },
  {
    title: "Cookies",
    points: [
      "AdsOne.lk uses cookies to maintain your session, remember preferences and analyse site usage.",
      "Cookies do not identify you personally on their own and cannot read files from your device.",
      "You can disable cookies in your browser settings, though some features of the site may not function correctly.",
    ],
  },
  {
    title: "Data Retention",
    points: [
      "We retain your account information for as long as your account is active.",
      "Deleted listings are removed from public view immediately but may be retained in backups for a limited period.",
      "You may request deletion of your account and associated data by contacting us at info@adsone.lk.",
    ],
  },
  {
    title: "Security",
    points: [
      "We use industry-standard measures to protect your data, including encrypted transmission (HTTPS) and secure storage.",
      "Passwords are stored in hashed form and are never visible to AdsOne staff.",
      "While we take reasonable precautions, no system is completely secure. Please use a strong, unique password for your account.",
    ],
  },
  {
    title: "Your Rights",
    points: [
      "You may access, correct or update your account information at any time through your Profile Settings.",
      "You may request a copy of the personal data we hold about you by contacting info@adsone.lk.",
      "You may request deletion of your account and personal data at any time.",
      "If you believe your data has been misused, you have the right to lodge a complaint with the relevant authority.",
    ],
  },
  {
    title: "Third-Party Links",
    points: [
      "AdsOne.lk may contain links to external websites. We are not responsible for the privacy practices of third-party sites.",
      "We recommend reviewing the privacy policy of any external site you visit.",
    ],
  },
  {
    title: "Changes to This Policy",
    points: [
      "We may update this Privacy Policy from time to time. Changes will be published on this page with an updated date.",
      "Continued use of AdsOne.lk after any changes constitutes your acceptance of the revised policy.",
    ],
  },
  {
    title: "Contact Us",
    points: [
      "If you have any questions or concerns about this Privacy Policy, please contact us at info@adsone.lk.",
      "Our support hours are Mon–Fri: 9am–6pm and Sat–Sun: 8am–5pm.",
    ],
  },
];

function PrivacyPolicyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Legal</p>
            <h1 className="info-page__title">Privacy Policy</h1>
            <p className="info-page__subtitle">
              This policy explains what data AdsOne collects, how we use it and your rights as a user of AdsOne.lk.
            </p>
          </div>

          {/* Sections */}
          <div className="info-page__body">
            {SECTIONS.map((section, i) => (
              <div key={i} className="info-section" style={{ flexDirection: "column", gap: "0.5rem" }}>
                <h3 className="info-section__title" style={{ marginBottom: 0 }}>
                  {i + 1}. {section.title}
                </h3>
                <ul className="info-section__list">
                  {section.points.map((p, j) => (
                    <li key={j} style={{ alignItems: "flex-start" }}>
                      <span style={{ color: "#ed1b24", fontWeight: 700, flexShrink: 0, marginTop: 1 }}>—</span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Last updated */}
          <div style={{ padding: "0 2.5rem 2rem", color: "#94a3b8", fontSize: "0.8125rem" }}>
            Last updated: 2026. For questions contact us at info@adsone.lk
          </div>

        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
